import type {
  TourProductFilters,
  TourProductSort,
} from './tours';

export type UrlParamPatch = Record<string, string | undefined>;

export interface TourCatalogUrlState {
  filters: TourProductFilters;
  sort: TourProductSort;
}

function list(value?: string): string[] {
  if (!value) return [];
  // Formato canónico: JSON. URLSearchParams se ocupa del percent-encoding y
  // cada nombre queda intacto aunque Rutero publique comas u otra puntuación.
  if (value.startsWith('[')) {
    try {
      const parsed: unknown = JSON.parse(value);
      if (Array.isArray(parsed) && parsed.every((item) => typeof item === 'string')) {
        return parsed.filter(Boolean);
      }
    } catch {
      // Un link escrito a mano o viejo cae al formato histórico de abajo.
    }
  }
  // Compatibilidad de lectura con URLs anteriores a la representación JSON.
  return value.split(',').map((item) => item.trim()).filter(Boolean);
}

/**
 * Refinamientos restaurables: la URL es la única fuente de verdad. Back,
 * Forward y un link compartido reconstruyen controles y resultados juntos.
 */
export function tourCatalogStateFromParams(
  params: Record<string, string>,
): TourCatalogUrlState {
  const requestedSort = params.orden;
  return {
    filters: {
      providers: list(params.fProveedor),
      categories: list(params.fCategoria),
      languages: list(params.fIdioma),
    },
    sort:
      requestedSort === 'title' || requestedSort === 'price'
        ? requestedSort
        : 'relevance',
  };
}

export function tourCatalogParams(
  filters: TourProductFilters,
  sort: TourProductSort,
): UrlParamPatch {
  const serialized = (values: string[]) =>
    values.length ? JSON.stringify(values) : undefined;
  return {
    fProveedor: serialized(filters.providers),
    fCategoria: serialized(filters.categories),
    fIdioma: serialized(filters.languages),
    orden: sort === 'relevance' ? undefined : sort,
  };
}
